import {Component, Input, OnInit} from '@angular/core';
import {PortalService} from "../services/portal.service";

/**
 * Teaser for the result page to give the possibility to link to another advisor.
 */
@Component({
    selector: 'app-advisor-teaser',
    templateUrl: './advisor.teaser.component.html',
    standalone: false
})
export class AdvisorTeaserComponent implements OnInit  {
  /**
   * placeholders for the texts
   */
  @Input() placeholder: any;

  /**
   * prefix for the main text and the button.
   */
  @Input() textPrefix: string;

  /**
   * postfix for main text and button
   */
  @Input() textPostfix: string = "";

  /**
   * prefix for the headline
   */
  @Input() headlinePostfix: string = "";

  /**
   * path to the image on the left side
   */
  @Input() image: string;

  /**
   * toggle for showing the image
   */
  @Input() showImage?: boolean = true;

  /**
   * url for the button
   */
  @Input() url: string = null;

  /**
   * url for the malto-link. leave empty to disable the feature
   */
  @Input() mailUrl: string = null;

  /**
   * target for the button, default ist _blank (new window)
   */
  @Input() target: string = '_blank';

  /**
   * change colomn order if true
   */
  @Input() changeColumnOrder: boolean = false;

  /**
   * toggle if internal or external portal
   */
  isInternalPortal: boolean = true;


  /**
   * constructor
   * @param portalService
   */
  constructor(protected portalService: PortalService) {  }

  ngOnInit() {
    this.isInternalPortal = this.portalService.isInternalPortal();
  }
}
